// removed by extract-text-webpack-plugin
module.exports = {"search":"search___1mmAB","searchLabel":"searchLabel___2KvmQ","searchLabelIcon":"searchLabelIcon___2082b","searchInput":"searchInput___2TajE","searchLabelText":"searchLabelText___1ubl7","hasSearch":"hasSearch___1A8Wd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InlineSearch/index.scss
// module id = 86
// module chunks = 0